const options = {
  5: "bg-teal-800/5",
  10: "bg-teal-800/10",
  25: "bg-teal-800/25",
  50: "bg-teal-800/50",
  75: "bg-teal-800/75",
  90: "bg-teal-800/90",
  100: "bg-teal-800",
};

const from = {
  5: "from-teal-800/5",
  10: "from-teal-800/10",
  25: "from-teal-800/25",
  50: "from-teal-800/50",
  75: "from-teal-800/75",
  90: "from-teal-800/90",
  100: "from-teal-800",
};

export default function getBackgroundTeal800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
